import styled, { css } from 'styled-components'
import { TagVariant } from './Tag.types'
import { media } from '../../../utils/mediaQuery'

const getVariantStyles = (variant: TagVariant) => {
  const variants = {
    blue: css`
      background: rgba(0, 173, 230, 0.1);
      color: #0099cc;
    `,
    green: css`
      background: rgba(0, 179, 65, 0.1);
      color: #00994d;
    `,
    purple: css`
      background: rgba(128, 90, 213, 0.1);
      color: #7b61ff;
    `,
    orange: css`
      background: rgba(255, 149, 0, 0.1);
      color: #ff8800;
    `,
    red: css`
      background: rgba(255, 59, 48, 0.1);
      color: #ff3333;
    `,
    yellow: css`
      background: rgba(255, 204, 0, 0.1);
      color: #ffaa00;
    `,
    gray: css`
      background: rgba(0, 0, 0, 0.05);
      color: #666666;
    `,
  }
  return variants[variant] || variants.gray
}

const getSizeStyles = (size: 'small' | 'medium') => {
  return size === 'small'
    ? css`
        padding: 3px 8px;
        font-size: 10px;
        gap: 3px;
        border-radius: 4px;
      `
    : css`
        padding: 4px 10px;
        font-size: 11px;
        gap: 4px;
        border-radius: 6px;
      `
}

export const StyledTag = styled.span<{
  $variant: TagVariant
  $size: 'small' | 'medium'
  $clickable: boolean
}>`
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  transition: all 0.2s;
  user-select: none;

  ${({ $variant }) => getVariantStyles($variant)}
  ${({ $size }) => getSizeStyles($size)}

  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      &:active {
        transform: translateY(0);
      }
    `}

  ${media.tabletDown} {
    ${({ $size }) =>
      $size === 'medium' &&
      css`
        padding: 3px 8px;
        font-size: 10px;
      `}
  }

  /* Mobile: Ensure clickable tags have adequate touch target */
  @media (max-width: 1023px) {
    ${({ $clickable }) =>
      $clickable &&
      css`
        min-height: 32px;
        padding: 8px 12px;
      `}
  }

  /* Disable hover effects on touch devices */
  @media (hover: none) {
    ${({ $clickable }) =>
      $clickable &&
      css`
        &:hover {
          transform: none;
          box-shadow: none;
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
      `}
  }
`

export const TagIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 12px;
    height: 12px;
  }
`
